import { render, staticRenderFns } from "./DirectGroup2.vue?vue&type=template&id=4b3b31d0&"
import script from "./DirectGroup2.vue?vue&type=script&lang=js&"
export * from "./DirectGroup2.vue?vue&type=script&lang=js&"
import style0 from "./DirectGroup2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDialog,VDivider,VFlex,VIcon,VProgressCircular,VSelect,VToolbar,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b3b31d0')) {
      api.createRecord('4b3b31d0', component.options)
    } else {
      api.reload('4b3b31d0', component.options)
    }
    module.hot.accept("./DirectGroup2.vue?vue&type=template&id=4b3b31d0&", function () {
      api.rerender('4b3b31d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/DirectGroup2.vue"
export default component.exports